export const hasVideoContent = (el: HTMLDivElement) => {
  return !!el.querySelectorAll(
    'div[data-youtube-video], div[data-video], div[data-vimeo-video]'
  ).length;
};
